// extracted by mini-css-extract-plugin
module.exports = {"tooltipBody":"TooltipInfo_tooltipBody__lTvPq","iconHide":"TooltipInfo_iconHide__fr2eD","label":"TooltipInfo_label__31R43","value":"TooltipInfo_value__3tFuK"};